import { VisitItem } from "../../../api/medcard.types";
import { MedcardOnlineVisitsByPatientAction } from "./medcard.online_visits.bypatient.types";

export const medcardOnlineVisitsByPatientRequestAction = (params: { medic_user_id: number }): MedcardOnlineVisitsByPatientAction => ({ type: 'MEDCARD_ONLINE_VISITS_BY_PATIENT_REQUEST', params })

export const medcardOnlineVisitsByPatientSuccessAction = (visits: VisitItem[]): MedcardOnlineVisitsByPatientAction => ({ type: 'MEDCARD_ONLINE_VISITS_BY_PATIENT_SUCCESS', params: visits })

export const medcardOnlineVisitsByPatientFailureAction = (error?: any): MedcardOnlineVisitsByPatientAction => ({ type: 'MEDCARD_ONLINE_VISITS_BY_PATIENT_FAILURE', params: error })